module.exports = __webpack_public_path__ + "images/125_1024.jpg";